import { render } from "./JournalVoucherList.vue?vue&type=template&id=7256eb70"
import script from "./JournalVoucherList.vue?vue&type=script&lang=js"
export * from "./JournalVoucherList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__